import { DropdownMenu } from 'radix-ui'
import { Menu, LogOut, HardDrive } from 'lucide-react'
import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import type { Session } from '@/lib/api/client'
import { useShellContext } from './shell-context-queries'
import { useUIStore } from './ui-store'

export function DashboardHeader({
  search,
  onSearch,
  session,
  onLogout,
  loggingOut,
}: {
  search: string
  onSearch: (value: string) => void
  session?: Session
  onLogout: () => void
  loggingOut: boolean
}) {
  const shellContext = useShellContext()
  return (
    <header className="dashboard-header">
      <Button
        variant="ghost"
        size="icon"
        className="mobile-menu"
        id="mobile-menu-trigger"
        aria-label="เปิดเมนู"
        onClick={() => useUIStore.getState().setDrawerOpen(true)}
      >
        <Menu size={22} />
      </Button>
      <div className="dashboard-search">
        <img src="/assets/dashboard/search.svg" alt="" />
        <Input
          type="search"
          aria-label="ค้นหารายการยา บิลเลขที่ หรือรหัสสินค้า"
          placeholder="ค้นหารายการยา, บิลเลขที่, หรือรหัสสินค้า..."
          value={search}
          onChange={(event) => onSearch(event.target.value)}
        />
      </div>
      {shellContext.isError || shellContext.mode.status === 'error' ? (
        <span className="dashboard-branch" role="alert">
          โหลดข้อมูลสาขาไม่ได้{' '}
          <Button
            variant="ghost"
            size="sm"
            onClick={() =>
              shellContext.mode.status === 'error'
                ? shellContext.mode.retry()
                : void shellContext.refetch()
            }
          >
            ลองใหม่
          </Button>
        </span>
      ) : (
        <span className="dashboard-branch">
          สาขา:{' '}
          {(shellContext.mode.status === 'ready'
            ? shellContext.data?.branch
            : undefined) ?? 'กำลังโหลด…'}
        </span>
      )}
      <div className="dashboard-shift">
        <div>
          <strong>
            {(shellContext.mode.status === 'ready'
              ? shellContext.data?.dateLabel
              : undefined) ?? '—'}
          </strong>
          <span>
            เริ่มกะ:{' '}
            {(shellContext.mode.status === 'ready'
              ? shellContext.data?.shiftStart
              : undefined) ?? '—'}{' '}
            น.
          </span>
        </div>
        <img src="/assets/dashboard/calendar.svg" alt="" />
      </div>
      {session && (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button
              type="button"
              className="dashboard-profile"
              aria-label="เมนูบัญชีผู้ใช้"
            >
              <span className="dashboard-profile-text">
                <strong className="user-chip">
                  {session.user.displayName}
                </strong>
                <span>
                  {(shellContext.mode.status === 'ready'
                    ? shellContext.data?.roleLabel
                    : undefined) ?? '—'}
                </span>
              </span>
              <img
                className="dashboard-avatar"
                src="/assets/dashboard/profile.png"
                alt=""
              />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content
              className="dashboard-account-menu"
              align="end"
              sideOffset={10}
            >
              <DropdownMenu.Label>
                {session.user.displayName}
              </DropdownMenu.Label>
              <DropdownMenu.Item asChild>
                <Link to="/offline">
                  <HardDrive size={16} />
                  ตรวจสอบอุปกรณ์
                </Link>
              </DropdownMenu.Item>
              <DropdownMenu.Item disabled={loggingOut} onSelect={onLogout}>
                <LogOut size={16} />
                ออกจากระบบ
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      )}
    </header>
  )
}
